const React = require('react')
const styles = require('./footer_logo.less')
const withStyles = require('withStyles').default
const PropTypes = require('prop-types')

function FooterLogo({ template }) {
    return (<div className={styles.scope}>
        <a href="/" className={`${template}-template`}>about.me</a>
    </div>)
}

FooterLogo.propTypes = {
    template: PropTypes.string,
}

module.exports = withStyles(styles)(FooterLogo)
